import { GoogleMap, useJsApiLoader } from "@react-google-maps/api";
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import { useEffect, useRef, forwardRef, useImperativeHandle } from "react";
import "./infoWindowStyle.css";

const containerStyle = {
  width: "100%",
  height: "calc(100vh - 90px)",
};
const MAP_ID = "ac7786045962af8b5e62cff6";

// const center = { lat: 4.81333, lng: -75.6961 };
const center = { lat: 4.81333, lng: -75.6961 } // Bogotá por defecto

const GoogleMapComponent = forwardRef(({ vehiclesRef, vehiclesReady }, ref) => {
  const mapRef = useRef(null);
  const clusterRef = useRef(null);
  const infoWindowRef = useRef(null);
  const iconsRef = useRef(null);

  // id → Marker
  const markersMapRef = useRef(new Map());

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyDryqrcseurbwqIRH0xTO7FTASbFKXPkKM",
  });

  useImperativeHandle(ref, () => ({
    centerToVehicle(vehicleId) {
      const vehicle = vehiclesRef.current.get(vehicleId);
      const marker = markersMapRef.current.get(vehicleId);
      const map = mapRef.current;

      if (!vehicle || !marker || !map) return;

      // 🎯 Centrar mapa
      map.panTo({
        lat: vehicle.latitude,
        lng: vehicle.longitude,
      });

      // 🔍 Zoom
      map.setZoom(17);

      // 🎯 Abrir InfoWindow
      // infoWindowRef.current?.open({
      //   map,
      //   anchor: marker,
      // });

      // ✨ Animación (opcional)
      marker.setAnimation(window.google.maps.Animation.BOUNCE);
      setTimeout(() => marker.setAnimation(null), 1200);
    },
  }));
  
  // const mapOptions = useMemo(
  //   () => ({
  //     mapId: MAP_ID,
  //     mapTypeId: "roadmap",
  //     disableDefaultUI: false,
  //     clickableIcons: false,
  //     scrollwheel: true,
  //   }),
  //   []
  // );

  // ==============================
  // Crear markers UNA VEZ
  // ==============================
  useEffect(() => {
    if (!isLoaded || !mapRef.current || !vehiclesReady) return;
    if (!window.google) return;

    if (!infoWindowRef.current) {
      infoWindowRef.current = new window.google.maps.InfoWindow();
    }

    if (!iconsRef.current) {
      iconsRef.current = {
        disponible: {
          url: `${window.location.origin}/icons/icon_taxi_amarillo.png`,
          scaledSize: new window.google.maps.Size(34, 46),
          anchor: new window.google.maps.Point(17, 23),
        },
        servicio: {
          url: `${window.location.origin}/icons/taxi_en_servicio.png`,
          scaledSize: new window.google.maps.Size(34, 48),
          anchor: new window.google.maps.Point(17, 23),
        },
      };
    }

    const markers = [];

    vehiclesRef.current.forEach(v => {
      if (isNaN(v.latitude) || isNaN(v.longitude)) return;

      const marker = new window.google.maps.Marker({
        position: { lat: v.latitude, lng: v.longitude },
        map: mapRef.current,
        icon: iconsRef.current.disponible,
      });

      const [dateOnly, timeOnly] = v.recorded_at
        ? v.recorded_at.split(/[ T]/)
        : ["", ""];

      marker.addListener("click", () => {
        const content = `
          <div class="iw-card">
            <div class="iw-header">
              🚖 Información del Taxi
            </div>

            <div class="iw-body">
              <div class="iw-row">
                <span class="iw-label">Vehículo</span>
                <span class="iw-value">${v.brand ?? '-'}</span>
              </div>

              <div class="iw-row">
                <span class="iw-label">Lateral</span>
                <span class="iw-value">${v.lateral ?? '-'}</span>
              </div>

              <div class="iw-row">
                <span class="iw-label">Placa</span>
                <span class="iw-value">${v.plate ?? v.id}</span>
              </div>

              <div class="iw-row">
                <span class="iw-label">Conductor</span>
                <span class="iw-value">${v.driver_name ?? 'Sin asignar'}</span>
              </div>

              <div class="iw-row">
                <span class="iw-label">Estado</span>
                <span class="iw-value ${
                  v.estado === 'En Servicio' ? 'bg-success' : 'bg-secondary'
                } text-white px-2 py-1 border-none rounded-pill">
                  ${v.estado === 'En Servicio' ? 'En Servicio' : 'Disponible'}
                </span>
              </div>
            </div>

            <div class="iw-footer">
              <span>🕒 ${timeOnly ?? '-'}</span>
              <span>📅 ${dateOnly ?? '-'}</span>
            </div>
          </div>
        `;

        infoWindowRef.current.setContent(content);
        infoWindowRef.current.open({
          map: mapRef.current,
          anchor: marker,
        });
      });

      markersMapRef.current.set(v.id, marker);
      markers.push(marker);
    });

    clusterRef.current = new MarkerClusterer({
      map: mapRef.current,
      markers,
    });
  }, [isLoaded, vehiclesReady]);

  // ==============================
  // FUTURO: actualizar posiciones
  // ==============================
  useEffect(() => {
    if (!vehiclesReady || !mapRef.current) return;
    let needsRepaint = false;

    const interval = setInterval(() => {
      console.log('interval: ', markersMapRef.current);

      vehiclesRef.current.forEach(v => {
        const marker = markersMapRef.current.get(v.id);
        if (!marker) return;

        if (isNaN(v.latitude) || isNaN(v.longitude)) return;

        marker.setPosition({
          lat: v.latitude,
          lng: v.longitude,
        });

        const expectedIcon = 
          v.estado === "En Servicio" ?
            iconsRef.current.servicio : 
            iconsRef.current.disponible;
        
        if(marker.getIcon().url !== expectedIcon.url) {
          console.log('into expect if');
          marker.setIcon(expectedIcon);
        }
      });
    }, 30000);

    return () => clearInterval(interval);
  }, [vehiclesReady]);

  if (!isLoaded) return <div>Cargando mapa…</div>;

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={14}
      onLoad={map => {
        mapRef.current = map;

        map.addListener("click", () => {
          infoWindowRef.current?.close();
        });
      }}
      options={{
        clickableIcons: false,
        disableDefaultUI: false
      }}
    />
  );
});

export default GoogleMapComponent;